import { ErrorContent } from "./http";
import config from "../config";

export const handleError = (res: ErrorContent) => {
  const error = res;

  if (res.status === 401 || res.status === 403) {
    if (!window.location.href.includes("/error/unauthorized")) {
      window.location.href = "/error/unauthorized";
    }
  }

  console.error(error);
  throw error;
};

export const { SERVICES_URL } = config;
